import { ADDFORMDATA, DELETESINGLEROW } from "./actionTypes"

export const addFormData = (data) => {
    return {
        type: ADDFORMDATA,
        payload: data
    }
}
export const deleteSingleRow = (index) => {
    return {
        type: DELETESINGLEROW,
        payload: index
    }
}